import { toast } from '@finn-no/common-browserbundle';

export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('geo-sort-failed').subscribe(showSortByClosestErrorMsg);

        function showSortByClosestErrorMsg() {
            toast({ message: 'Sortér på "Nærmest" feilet', level: 'error' });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchSort.js